<template>
    <div>
        <h2 class="name">
            Fusebox + {{ integrationName }} Integration
        </h2>
        <h4 class="title">
            Need help adding Fusebox 2.0 to {{ integrationName }}?
        </h4>
        <p class="text">
            We've gathered all the instructions you'll need to make embedding your players a breeze! Plus, any future customizations you make to your players will be automatically updated through the embed code! No need to replace the code once it's there.
        </p>
        <a class="arrow-link" :href="integrationLink" target="_blank">Learn more <i class="far fa-long-arrow-right" /></a>
    </div>
</template>

<script>
export default {
    props: {
        integrationName: {
            type: String,
            default: () => '',
        },
        integrationTitle: {
            type: String,
            default: () => '',
        },
        integrationText: {
            type: String,
            default: () => '',
        },
        integrationLink: {
            type: String,
            default: () => '',
        },
        helpScoutId: {
            type: String,
            default: '',
        },
    },
};
</script>
